import { createTourStore } from "@features/onboarding/create-tour-store";

export const {
  useStore: usePlatformTourStore,
  useStoreShallow: usePlatformTourStoreShallow,
} = createTourStore("sd:onboarding-platform-tour");
